import { render, staticRenderFns } from "./dog-intact-select.vue?vue&type=template&id=64c43f0a&"
import script from "./dog-intact-select.vue?vue&type=script&lang=js&"
export * from "./dog-intact-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports